import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";

import { clickBanner } from "../../../libs/banner";
import { gaClickBanner } from "../../../libs/ga";

import { BannerItem, LinkLocationType } from "../../../services/bannerServices";

import DefaultBanner from "../../Banner";

type Props = {
  banners: BannerItem[];
  position: LinkLocationType;
};

export default function BannerSwiper({ banners, position }: Props) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleChange = (swiper: any) => {
    setActiveIndex(swiper.activeIndex);
  };

  return (
    <div className="relative">
      <Swiper
        onSlideChange={handleChange}
        spaceBetween={window.innerWidth > 760 ? 16 : 11}
        slidesPerView={1.1}
        className="w-full"
        slidesOffsetBefore={22}
        slidesOffsetAfter={22}
      >
        {banners.map((banner, index) => (
          <SwiperSlide
            key={index}
            onClick={() => {
              gaClickBanner(position, banner);
              clickBanner(banner);
            }}
          >
            <DefaultBanner
              item={banner}
              position={position}
              className="w-full h-full"
              imageClassName="rounded-xl object-cover"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="absolute w-full top-full z-10 flex gap-1 mt-2.5 justify-center">
        {banners.map((_, index) => (
          <div
            key={index}
            className={`w-[6px] h-[6px] rounded-full ${
              activeIndex === index ? "bg-black" : "bg-gray-300"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
}
